module.exports = __webpack_public_path__ + "static/Plant-Monitoring-c4ce2115d047eb1cd74d0afc8f935cda.jpg";